import axiosAuth from '../../axiosMain';

async function index() {
  let response = await axiosAuth.get('/consumption_categories');
  return response.data.data;
}

async function show(id) {
  let response = await axiosAuth.get('/consumption_categories/' + id);
  return response.data.data;
}

export default {
  index,
  show,
};
